import Page from '../models/page';

function initHomepage() {
  if (Page.controller !== 'static_pages' || Page.action !== 'home' || Page.isLoggedIn) return;

  const $school = $('#school');
  const $signupForm = $('#sign-up-form');

  $school.typeahead({
    name: 'School',
    local: $school.data('source'),
  });

  if (!$signupForm.length) return;

  $signupForm.parsley({
    inputs: 'input[name^="user"], select[name^="user"], input[name=school]',
    trigger: 'change submit',
  });

  $signupForm.parsley().addAsyncValidator('remoteValidator', (xhr) => xhr.responseJSON.valid);

  const $submitButton = $signupForm.find('input[type="submit"]');
  $submitButton.submit(function() {
    if ($signupForm.parsley().isValid()) {
      $submitButton.attr('disabled', 'disabled').val('Creating your account...');
    }
  });
}

export default initHomepage;
